
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  reactive,
  watch,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();
    const route = useRoute();
    const eventData = computed(() => store.getters["user/eventData"]);
    const program = ref({});
    const itemToShow = ref(null);
    const isActive = ref(false);
    const selectedEvents: Array<any> = reactive([]);
    const arrAM: Array<any> = reactive([]);
    const arrPM: Array<any> = reactive([]);
    const arr12AM: Array<any> = reactive([]);
    const arr12PM: Array<any> = reactive([]);
    const showCheckoutConfirmation = ref(false);
    store.dispatch("user/getFeaturesAccess", "courses_and_program");
    const course = ref();
    watch(eventData, async (newValue, lastValue) => {
      if (newValue != lastValue) {
        await getProgram();
        selectFirstDate();
      }
    });

    const logged = computed(() => {
      return store.getters["user/isLogged"];
    });
    const userData = computed(() => {
      return store.getters["user/participantData"];
    });
    const getProgramInfo = (data) =>
      store.dispatch("user/getProgramData", data);

    const getProgram = async () => {
      program.value = await getProgramInfo({
        eventID: route.params.eventID,
      });
      sortEvent(program.value, compareStartDates);
      sortEvent(program.value, compareToDates);
    };
    function selectFirstDate() {
      const firstEvent = program.value[Object.keys(program.value)[0]];
      selectDay(1, firstEvent);
    }

    function compareStartDates(a, b) {
      const firstDate: number = new Date(a.fromTime * 1000).valueOf();
      const nextDate: number = new Date(b.fromTime * 1000).valueOf();
      return firstDate - nextDate;
    }

    function compareToDates(a, b) {
      const firstDate: number = new Date(a.toTime * 1000).valueOf();
      const nextDate: number = new Date(b.toTime * 1000).valueOf();
      return firstDate - nextDate;
    }

    function sortEvent(events, functionCompare) {
      for (const item in events) {
        events[item].sort(functionCompare);
      }
    }

    function orderEvent(arr, indexA, indexB) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 1; j < arr.length - i; j++) {
          if (
            parseInt(arr[j - 1].startTime.slice(indexA, indexB)) >=
              parseInt(arr[j].startTime.slice(indexA, indexB)) &&
            parseInt(arr[j - 1].endTime.slice(indexA, indexB)) >=
              parseInt(arr[j].endTime.slice(indexA, indexB))
          ) {
            const temp = arr[j - 1];
            arr[j - 1] = arr[j];
            arr[j] = temp;
          }
        }
      }
    }

    function orderProgram(events) {
      arrAM.splice(0, arrAM.length);
      arrPM.splice(0, arrPM.length);
      arr12PM.splice(0, arr12PM.length);
      arr12AM.splice(0, arr12AM.length);
      for (let i = 0; i < events.length; i++) {
        if (
          parseInt(events[i].startTime.slice(0, 5)) === 12 &&
          events[i].startTime.slice(6, 8) === "pm"
        ) {
          arr12PM.push(events[i]);
        } else if (
          parseInt(events[i].startTime.slice(0, 5)) === 12 &&
          events[i].startTime.slice(6, 8) === "am"
        ) {
          arr12AM.push(events[i]);
        } else if (
          events[i].startTime.slice(6, 8) === "am" &&
          parseInt(events[i].startTime.slice(0, 5)) != 12
        ) {
          arrAM.push(events[i]);
        } else if (
          events[i].startTime.slice(6, 8) === "pm" &&
          parseInt(events[i].startTime.slice(0, 5)) != 12
        ) {
          arrPM.push(events[i]);
        }
      }

      if (arrAM.length > 1 && arrAM.length > 1) {
        orderEvent(arrAM, 0, 5);
        orderEvent(arrPM, 0, 5);
      } else if (arrAM.length > 1 && arrPM.length <= 1) {
        orderEvent(arrAM, 0, 5);
      } else if (arrAM.length <= 1 && arrPM.length > 1) {
        orderEvent(arrPM, 0, 5);
      }
      return arr12AM.concat(arrAM, arr12PM, arrPM);
    }

    function selectDay(day, events) {
      const arrEvents = orderProgram(events);
      selectedEvents.splice(0, selectedEvents.length);
      for (const item of arrEvents) {
        selectedEvents.push(item);
      }
      isActive.value = true;
      itemToShow.value = day;
    }

    function getActiveClass(index) {
      const activeClass = `active${itemToShow.value}`;
      if (index + 1 == itemToShow.value) {
        return { [activeClass]: true };
      } else {
        return false;
      }
    }

    function convertHours(time) {
      const date = new Date(time * 1000);
      let hours: string | number = date.getHours();
      let minutes: string | number = date.getMinutes();
      let seconds: string | number = date.getSeconds();
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      const strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    }
    function getFormat(utc, required) {
      let value;
      let fullDate;
      switch (required) {
        case "day":
          value = new Date(parseInt(utc)).getDate();
          break;
        case "month":
          fullDate = new Date(parseInt(utc)).toDateString();
          value = fullDate.substring(3, 7);
          break;
        case "year":
          value = new Date(parseInt(utc)).getFullYear();
          break;
      }
      return value;
    }
    onMounted(async () => {
      if (eventData.value) {
        await getProgram();
        selectFirstDate();
      }
    });
    const onRegisterActivity = async (event, confirm) => {
      if (event) course.value = event;
      const start = new Date(course.value.dateStart).getTime();
      const end = new Date(course.value.dateEnd).getTime();
      const today = new Date().getTime();
      if (today >= start && today <= end && !confirm)
        showCheckoutConfirmation.value = true;
      else {
        await store.dispatch("program/registerCourse", {
          courseID: course.value.id,
          eventID: route.params.eventID,
          participantID: userData.value.uid,
        });
      }
    };
    const downloadPDF = async () => {
      await store.dispatch("program/downloadEventProgram", {
        eventID: route.params.eventID,
      });
    };
    return {
      eventData,
      getProgramInfo,
      getProgram,
      program,
      selectDay,
      itemToShow,
      isActive,
      getActiveClass,
      convertHours,
      selectedEvents,
      logged,
      onRegisterActivity,
      userData,
      getFormat,
      showCheckoutConfirmation,
      downloadPDF,
    };
  },
});
